<section class="operational-section">
    <header class="operational-section__header">
        <div class="operational-section__titles">
            <h3 class="operational-section__title">{{ title }}</h3>
            <p *ngIf="subtitle" class="operational-section__subtitle">{{ subtitle }}</p>
        </div>
        <p *ngIf="summary" class="operational-section__summary">{{ summary }}</p>
    </header>

    <div *ngIf="loading" class="operational-section__state">Loading…</div>
    <div *ngIf="!loading && errorMessage" class="operational-section__state operational-section__state--error">
        {{ errorMessage }}
    </div>
    <div *ngIf="!loading && !errorMessage && emptyMessage" class="operational-section__state">
        {{ emptyMessage }}
    </div>

    <div *ngIf="!loading && !errorMessage && !emptyMessage" class="operational-section__body">
        <ng-content></ng-content>
    </div>
</section>
